<script>
/**
 * Comments Rev. 3 (spec 2026-10-18-comments-design, plan 3b): the editor shows no comments; this counts the open threads
 * of the shown language for the header button, which opens the preview to comment. Renders nothing.
 */
import GetPageComments from '@/graphQlQueries/queries/getPageComments';
import { toThreads, openCount, languageIdFor } from '@/utils/comments';

const POLL_MS = 60000;

export default {
  name: 'CommentsCount',
  props: {
    enabled: { type: Boolean, default: false },
    pageId: { type: Number, required: true },
    translationSetup: { type: Object, default: null },
  },
  data: () => ({
    rows: [],
    picked: null,
    timer: null,
  }),
  computed: {
    open() {
      return openCount(toThreads(this.rows, languageIdFor(this.translationSetup, this.picked)));
    },
  },
  watch: {
    enabled(on) {
      if (on) this.load();
      this.announce();
    },
    open() {
      this.announce();
    },
  },
  mounted() {
    this.$root.$on('keditor-comments-frage', this.announce);
    this.$root.$on('keditor-comments-changed', this.load);
    this.$root.$on('keditor-language', this.setPicked);
    this.$root.$on('keditor-languages', this.setLanguages);
    if (this.enabled) this.load();
    this.timer = setInterval(this.load, POLL_MS);
    this.announce();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.$root.$off('keditor-comments-frage', this.announce);
    this.$root.$off('keditor-comments-changed', this.load);
    this.$root.$off('keditor-language', this.setPicked);
    this.$root.$off('keditor-languages', this.setLanguages);
    this.$root.$emit('keditor-comments', { enabled: false, open: 0 });
  },
  methods: {
    announce() {
      this.$root.$emit('keditor-comments', { enabled: this.enabled, open: this.enabled ? this.open : 0 });
    },
    // A direct query, never a smart query: a smart refetch flips $apollo.loading and unmounts the editor (PageItem).
    async load() {
      if (!this.enabled) return;
      try {
        const { data } = await this.$apollo.query({ query: GetPageComments, variables: { pageId: this.pageId }, fetchPolicy: 'no-cache' });
        this.rows = (data && data.page_comments) || [];
      } catch (e) {
        // The count stays as it was; the next poll tries again.
      }
    },
    setPicked(lang) {
      this.picked = lang || null;
    },
    setLanguages(payload) {
      this.picked = (payload && payload.active) || null;
    },
  },
  render() {
    return null;
  },
};
</script>
